import type { PlaceBasic } from './types';

export type PlaceSourceData = {
  rating: number | null;
  reviewCount: number | null;
  link: string | null;
};

export function getPlaceSourceData(place: PlaceBasic, source: string): PlaceSourceData {
  switch (source) {
    case 'yelp':
      return {
        rating: place.yelp_rating ?? null,
        reviewCount: place.yelp_total_review_count ?? null,
        link: place.yelp_link ?? null,
      };
    case 'bbb':
      return {
        rating: place.bbb_rating ?? null,
        reviewCount: place.bbb_total_review_count ?? null,
        link: place.bbb_link ?? null,
      };
    case 'dealerrater':
      return {
        rating: place.dealerrater_rating ?? null,
        reviewCount: place.dealerrater_total_review_count ?? null,
        link: place.dealerrater_link ?? null,
      };
    case 'opentable':
      return {
        rating: place.opentable_rating ?? null,
        reviewCount: place.opentable_total_review_count ?? null,
        link: place.opentable_link ?? null,
      };
    case 'tripadvisor':
      return {
        rating: place.tripadvisor_rating ?? null,
        reviewCount: place.tripadvisor_total_review_count ?? null,
        link: place.tripadvisor_link ?? null,
      };
    case 'carscom':
      return {
        rating: place.carscom_rating ?? null,
        reviewCount: place.carscom_total_review_count ?? null,
        link: place.carscom_link ?? null,
      };
    case 'carfax':
      return {
        rating: place.carfax_rating ?? null,
        reviewCount: place.carfax_total_review_count ?? null,
        link: place.carfax_link ?? null,
      };
    case 'edmunds':
      return {
        rating: place.edmunds_rating ?? null,
        reviewCount: place.edmunds_total_review_count ?? null,
        link: place.edmunds_link ?? null,
      };
    case 'cargurus':
      return {
        rating: place.cargurus_rating ?? null,
        reviewCount: place.cargurus_total_review_count ?? null,
        link: place.cargurus_link ?? null,
      };
    case 'booking':
      return {
        rating: place.booking_rating ?? null,
        reviewCount: place.booking_total_review_count ?? null,
        link: place.booking_link ?? null,
      };
    case 'expedia':
      return {
        rating: place.expedia_rating ?? null,
        reviewCount: place.expedia_total_review_count ?? null,
        link: place.expedia_link ?? null,
      };
    case 'golfpass':
      return {
        rating: place.golfpass_rating ?? null,
        reviewCount: place.golfpass_total_review_count ?? null,
        link: place.golfpass_link ?? null,
      };
    default:
      return {
        rating: place.rating ?? null,
        reviewCount: place.total_review_count ?? null,
        link: place.cid_url ?? null,
      };
  }
}
